'use es6';

import { Component } from 'react';
import PropTypes from 'prop-types';
import { addOrRemoveClassesToElement } from 'layout-dnd-utils/dom/manipulators';
import { uniq, difference } from 'underscore';
export default class LayoutSectionStylesApplicator extends Component {
  componentDidMount() {
    this.domElement = this.getDomElementForNode(this.props.domSelector);
    if (this.domElement) {
      const {
        previousClasses,
        currentClasses
      } = this.computeClassDifferences();
      addOrRemoveClassesToElement(this.domElement, previousClasses, currentClasses);
    }
  }
  componentDidUpdate(prevProps) {
    const {
      domSelector,
      layoutSectionRenderCount
    } = this.props;
    let hasDomElementChange = false;
    // If the layout section re-rendered, grab a handle on the new dom node associated
    // with this dom selector. Right now when a layout section renders it blows
    // away all the columns / rows / cell wrappers and recreates them from scratch.
    // This check forces the layout style applicator to grab a reference to the newly created
    // dom nodes if needed.
    // TODO: In the future if we make it so layout section trees don't get
    // completely demolished when rendering updates (say, it only renders the column that changed),
    // we can pair this check with a document.body.contains(this.domElement) check to skip re-querying
    // the dom if the dom element this applicator is tied to didn't change
    if (layoutSectionRenderCount !== prevProps.layoutSectionRenderCount) {
      this.domElement = this.getDomElementForNode(domSelector);
      hasDomElementChange = true;
    }
    const {
      previousClasses,
      currentClasses,
      hasClassChange
    } = this.computeClassDifferences(prevProps);
    if (this.domElement && (hasDomElementChange || hasClassChange)) {
      addOrRemoveClassesToElement(this.domElement, previousClasses, currentClasses);
    }
  }
  componentWillUnmount() {
    const currentStyles = this.props.styles;
    const currentClasses = currentStyles.map(style => style.className);
    if (this.domElement) {
      addOrRemoveClassesToElement(this.domElement, currentClasses, []);
    }
  }
  getDomElementForNode(domNodeSelector) {
    return document.querySelector(domNodeSelector);
  }
  pullClassnamesFromStyles(styleArray) {
    return uniq(styleArray.map(style => style.className).filter(className => className != null));
  }
  computeClassDifferences(prevProps = {}) {
    const {
      styles
    } = this.props;
    const currentStyles = styles;
    const previousStyles = prevProps.styles || [];
    const previousClasses = this.pullClassnamesFromStyles(previousStyles);
    const currentClasses = this.pullClassnamesFromStyles(currentStyles);
    if (previousClasses.length !== currentClasses.length) {
      return {
        previousClasses,
        currentClasses,
        hasClassChange: true
      };
    } else {
      const hasClassChange = difference(currentClasses, previousClasses).length > 0;
      return {
        previousClasses,
        currentClasses,
        hasClassChange
      };
    }
  }
  render() {
    return null;
  }
}
LayoutSectionStylesApplicator.propTypes = {
  styles: PropTypes.array.isRequired,
  domSelector: PropTypes.string.isRequired,
  layoutSectionRenderCount: PropTypes.number.isRequired
};